<template>
  
  <v-list dense>

    <!-- Back -->
    <v-list-item @click="$emit('back')">
      <v-list-item-icon>
        <v-icon disabled>mdi-chevron-left</v-icon>
      </v-list-item-icon>
      <v-list-item-content>
        <v-list-item-title>Video Quality</v-list-item-title>  
      </v-list-item-content>
    </v-list-item>

    <v-divider></v-divider>

    <!-- Alpha -->
    <v-list-item-group>
      <v-list-item
        v-if    = "mediaHasAlphaChannel"
        color   = "primary"
        :value  = "video.isAlphaSimulated"
        @change = "onSimulateAlpha"
      >
        <v-list-item-action>
          <v-checkbox 
            :input-value = "video.isAlphaSimulated"
          >
          </v-checkbox>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>Show Alpha</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list-item-group>

    <v-divider v-if="mediaHasAlphaChannel"></v-divider>

    <!-- Quality Level -->
    <v-list-item-group
      mandatory
      :value    = "currentLevel"
      @change   = "onSetQualityLevel"
    >

      <v-list-item
        v-for   = "level in progressiveLevels"
        :key    = "level.index"
        :value  = "level.index"
        color   = "primary"
      >
        <v-list-item-content>
          <v-list-item-title>{{ level.name }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-divider
        v-if    = "deinterlacedLevels.length > 0"
      >
      </v-divider>

      <v-list-item
        v-for   = "level in deinterlacedLevels"
        :key    = "level.index"
        :value  = "level.index"
        color   = "primary"
      >
        <v-list-item-content>
          <v-list-item-title>{{ level.name }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>    

    </v-list-item-group>

  </v-list>

</template>

<script lang="js">

// #region Imports

/* vuex */
import { mapState } from 'vuex';

/* Telestream */
import { 
  ADJUST_VIDEO_QUALITY,
  SIMULATE_ALPHA
} from '@/utils/action-types';

// #endregion Imports

// #region Constants

const ALPHA_CHANNEL_NAME_APPENDIX = ' Alpha channel';

// #endregion Constants

export default {

  // #region Properties

  name:     'VideoQualityMenu',
  computed: {

    ...mapState([
      'videoController',
      'video'
    ]),

    levels() {
      if (!this.videoController) {
        return [];
      }

      return this.videoController.hls.levels;
    },

    deinterlacedLevels() {
      return this.levels
        .map((l, index) => {
          return {
            index: index,
            name:  l.name
          }
        })
        .filter(l => l.name.includes('[') && !l.name.endsWith(ALPHA_CHANNEL_NAME_APPENDIX));
    },

    progressiveLevels() {
      return this.levels
        .map((l, index) => {
          return {
            index: index,
            name:  l.name
          }
        })
        .filter(l => !l.name.includes('[') && !l.name.endsWith(ALPHA_CHANNEL_NAME_APPENDIX));
    },

    currentLevel() {
      if (!this.videoController) {
        return;
      }

      let currentLevelIndex = this.videoController.currentLevel;
      if (this.levels.length === 0) {
        return;
      }

      if (this.levels[currentLevelIndex].name.endsWith(ALPHA_CHANNEL_NAME_APPENDIX)) {
        const nonAlphaLevelName = this.levels[currentLevelIndex].name.replace(ALPHA_CHANNEL_NAME_APPENDIX, '');
        currentLevelIndex = this.levels.findIndex(other => other.name === nonAlphaLevelName);
      }

      return currentLevelIndex;
    },

    mediaHasAlphaChannel() {
      return this.videoController && this.videoController.containsAlphaChannel;
    }

  },

  // #endregion Properties

  // #region Events

  methods: {

    onSetQualityLevel(index) {
      const level = this.levels[index];
      this.$store.dispatch(ADJUST_VIDEO_QUALITY, level);
    },

    onSimulateAlpha() {
      this.$store.dispatch(SIMULATE_ALPHA, !this.video.isAlphaSimulated);
    }

  }

  // #endregion Events

}

</script>